const storagePrefix = 'legend';

export function getItem(name) {
    return localStorage.getItem(`${storagePrefix}_${name}`);
}

export function setItem(name, value) {
    localStorage.setItem(`${storagePrefix}_${name}`, value);
}

export function removeItem(name) {
    localStorage.removeItem(`${storagePrefix}_${name}`);
}
